import Finances from '../src/Finances/index';
export default Finances;
